/*
    "promemo": "env-cmd -f .env.cyber.staging react-app-rewired start"
*/
export const BUILD_PROFILE = process.env.REACT_APP_BUILD_PROFILE ?? 'ALL'

export const APP_DOMANIN = process.env.REACT_APP_DOMAIN ?? '.6sicuro'
export const APP_CONVENZIONE = parseInt(process.env.REACT_APP_CONVENZIONE ?? "1")

// url base
export const SPECIFIC_MS_URL = process.env.REACT_APP_SPECIFIC_MS_URL ?? '#'
export const SAVE_MS_URL = SPECIFIC_MS_URL + '/save'
export const CALCULATE_CF_URL = SPECIFIC_MS_URL + '/calculate/cf'

// url validazioni comuni
export const NAMES_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/names'
export const OBJECTS_NAMES_URL = SPECIFIC_MS_URL + '/validate/company'
export const EMAIL_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/email'
export const PIVA_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/piva'
export const STREET_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/street'
export const PHONE_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/phone'
export const NUMBER_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/number'
export const TRAGA_TIPO_VEICOLO_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/targaVeicolo'


// url validazioni step -- se esistono -- non tutti i preventivatori hanno lo stesso numero di step
export const STEP_1_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/step1'
export const STEP_2_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/step2'
export const STEP_3_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/step3'
export const STEP_4_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/step4'
export const STEP_5_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/step5'

// url ricerche località - per nome
export const STATI_SEARCH_URL = SPECIFIC_MS_URL + '/location/findStato'
export const COMUNI_SEARCH_URL = SPECIFIC_MS_URL + '/location/findComune'
export const CAP_SEARCH_URL = SPECIFIC_MS_URL + '/location/findCap'

// url ricerche indirizzi
export const ADDRESS_SEARCH_URL = SPECIFIC_MS_URL + '/address/search'
export const ADDRESS_DETAILS_URL = SPECIFIC_MS_URL + '/address/details'

// url microservizio specifico -- ship
export const SHIP_PLATE_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/targaBarca'
export const SHIP_CODE_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/matricola'
export const SHIP_YEAR_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/annocostruzionemotore'
export const POWER_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/power'

// url microservizio specifico -- professional
export const PROFESSIONAL_SPECIALIZATION_VALIDATION_URL = SPECIFIC_MS_URL + "/validate/dettaglio_attivita"

// url microservizio specifico -- ship
export const MICROCAR_PLATE_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/targa_micro_car'

// url microservizio specifico -- veicoli commerciali -- auto epoca -- microcar
export const CAR_PLATE_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/targa_auto'
export const BIKE_PLATE_VALIDATION_URL = SPECIFIC_MS_URL + '/validate/targa_moto'

// url enum
const BASE_ENUM_URL = SPECIFIC_MS_URL + '/enums'
export const PROFESSIONI_URL = BASE_ENUM_URL + '/professione'
export const SESSO_URL = BASE_ENUM_URL + '/sesso'
export const STATI_URL = BASE_ENUM_URL + '/stati'
export const TOPONIMI_URL = BASE_ENUM_URL + '/toponimi'

export const DISPOSITIVI_URL = process.env.REACT_APP_DISPOSITIVI_PATH ?? '#'
export const FASCIA_PREZZI_URL = process.env.REACT_APP_FASCIA_PREZZI_PATH ?? '#'
export const ALIMENTAZIONE_URL = process.env.REACT_APP_ALIMENTAZIONE_PATH ?? '#'
export const ASSICURAZIONE_URL = process.env.REACT_APP_ASSICURAZIONE_PATH ?? '#'
export const UTILIZZO_URL = process.env.REACT_APP_UTILIZZO_PATH ?? '#'
export const REGIONI_URL = process.env.REACT_APP_REGIONI_PATH ?? '#'
export const LUOGHI_URL = process.env.REACT_APP_LUOGHI_PATH ?? '#'
export const UTILIZZO_CASA_URL = process.env.REACT_APP_UTILIZZO_CASA_PATH ?? '#'
export const TIPO_CASA_URL = process.env.REACT_APP_TIPO_CASA_PATH ?? '#'
export const ANNO_CASA_URL = process.env.REACT_APP_ANNO_CASA_PATH ?? '#'
export const MATERIALI_CASA_URL = process.env.REACT_APP_MATERIALI_CASA_PATH ?? '#'
export const STATO_CASA_URL = process.env.REACT_APP_STATO_CASA_PATH ?? '#'

export const TIPO_ANIMALI_URL = process.env.REACT_APP_TIPO_ANIMALI_PATH ?? '#'
export const TIPO_AREA_PROFESSIONALE_URL = process.env.REACT_APP_AREA_PROFESSIONALE_PATH ?? '#'
export const TIPO_AREA_GIURIDICA_URL = process.env.REACT_APP_AREA_GIURIDICA_PATH ?? '#'
export const TIPO_AREA_MEDICA_URL = process.env.REACT_APP_AREA_MEDICA_PATH ?? '#'
export const TIPO_AREA_TECNICA_URL = process.env.REACT_APP_AREA_TECNICA_PATH ?? '#'
export const TIPO_DIREZIONE_SANITARIA_URL = process.env.REACT_APP_DIREZIONE_SANITARIA_PATH ?? '#'
export const TIPO_MASSIMALE_URL = process.env.REACT_APP_MASSIMALE_PATH ?? '#'
export const TIPO_REGIME_URL = process.env.REACT_APP_REGIME_PATH ?? '#'
export const TIPO_RETROATTIVITA_URL = process.env.REACT_APP_RETROATTIVITA_PATH ?? '#'
export const TIPO_RISARCIMENTI_URL = process.env.REACT_APP_RISARCIMENTI_PATH ?? '#'
export const TIPO_TIPO_ASSICURAZIONE_URL = process.env.REACT_APP_TIPO_ASSICURAZIONE_PATH ?? '#'
export const PROFESSIONE_BY_AREA_URL = process.env.REACT_APP_PROFESSIONE_BY_AREA_PATH ?? '#'
export const ALL_PROFESSIONE_BY_AREA_URL = process.env.REACT_APP_ALL_PROFESSIONE_BY_AREA_PATH ?? '#'

export const TIPO_TIPO_PROFESSIONISTA_URL = process.env.REACT_APP_TIPO_PROFESSIONISTA_PATH ?? '#'
export const TIPO_ALTRE_ASSICURAZIONI_URL = process.env.REACT_APP_ALTRE_ASSICURAZIONI_PATH ?? '#'
export const TIPO_ATTIVITA_CHIRURGICA_URL = process.env.REACT_APP_ATTIVITA_CHIRURGICA_PATH ?? '#'
export const TIPO_COPERTURA_TRAVEL_URL = process.env.REACT_APP_TIPO_COPERTURA_TRAVEL_PATH ?? '#'
export const TIPO_DESTINAZIONE_TRAVEL_URL = process.env.REACT_APP_TIPO_DESTINAZIONE_TRAVEL_PATH ?? '#'
export const TIPO_DURATA_TRAVEL_URL = process.env.REACT_APP_TIPO_DURATA_TRAVEL_PATH ?? '#'
export const TIPO_NUMERO_FIGLI_TRAVEL_URL = process.env.REACT_APP_TIPO_NUMERO_FIGLI_TRAVEL_PATH ?? '#'
export const TIPO_PERSONA_TRAVEL_URL = process.env.REACT_APP_TIPO_PERSONA_TRAVEL_PATH ?? '#'
export const TIPO_VIAGGIO_TRAVEL_URL = process.env.REACT_APP_TIPO_VIAGGIO_TRAVEL_PATH ?? '#'
export const TIPO_SPORT_INJURY_URL = process.env.REACT_APP_TIPO_SPORT_INJURY_PATH ?? '#'
export const TIPO_TUTELATI_SALUTE_URL = process.env.REACT_APP_TUTELATI_SALUTE_PATH ?? '#'
export const TIPO_TUTELE_SALUTE_URL = process.env.REACT_APP_TUTELE_SALUTE_PATH ?? '#'
export const TIPO_REDDITO_SALUTE_URL = process.env.REACT_APP_REDDITO_SALUTE_PATH ?? '#'
export const TIPO_SITUAZIONI_SALUTE_URL = process.env.REACT_APP_SITUAZIONI_SALUTE_PATH ?? '#'
export const TIPO_MALATTIA_SALUTE_URL = process.env.REACT_APP_MALATTIA_SALUTE_PATH ?? '#'

export const TIPO_VEICOLO_COMMERCIALE_URL = process.env.REACT_APP_TIPO_VEICOLO_COMMERCIALE_PATH ?? '#'
export const TIPO_BICI_URL = process.env.REACT_APP_TIPO_BICI_PATH ?? '#'
export const TIPO_PARCHEGGIO_BICI_URL = process.env.REACT_APP_TIPO_PARCHEGGIO_BICI_PATH ?? '#'
export const TIPO_USO_BICI_URL = process.env.REACT_APP_TIPO_USO_BICI_PATH ?? '#'
export const FASCIA_PREZZO_BICI_URL = process.env.REACT_APP_FASCIA_PREZZO_BICI_PATH ?? '#'

export const TIPO_MICROCAR_URL = process.env.REACT_APP_TIPO_MICROCAR_PATH ?? '#'
export const TIPO_ALIMENTAZIONE_URL = process.env.REACT_APP_TIPO_ALIMENTAZIONE_PATH ?? '#'

export const TIPO_STATO_ASSICURATIVO_URL = process.env.REACT_APP_TIPO_STATO_ASSICURATIVO_PATH ?? '#'
export const TIPO_EREDITA_CU_URL = process.env.REACT_APP_TIPO_EREDITA_CU_PATH ?? '#'
export const TIPO_CU_EREDITATA_URL = process.env.REACT_APP_TIPO_CU_EREDITATA_PATH ?? '#'
export const TIPO_VEICOLO_EREDITA_CU_URL = process.env.REACT_APP_TIPO_VEICOLO_EREDITA_PATH ?? '#'
export const TIPO_CU_ATTUALE_URL = process.env.REACT_APP_TIPO_CU_ATTUALE_PATH ?? '#'
export const TIPO_ANZIANITA_PRIMA_CLASSE_URL = process.env.REACT_APP_TIPO_ANZIANITA_PRIMA_CLASSE_PATH ?? '#'
export const TIPO_COMPAGNIA_ATTUALE_URL = process.env.REACT_APP_TIPO_COMPAGNIA_ATTUALE_PATH ?? '#'
export const TIPO_ETA_ASSICURATIVA_URL = process.env.REACT_APP_TIPO_ETA_ASSICURATIVA_PATH ?? '#'
export const TIPO_ANNO_INCIDENTE_URL = process.env.REACT_APP_TIPO_ANNO_INCIDENTE_PATH ?? '#'
export const TIPO_RESPONSABILITA_INCIDENTE_URL = process.env.REACT_APP_TIPO_RESPONSABILITA_INCIDENTE_PATH ?? '#'
export const TIPO_MARCE_VEICOLO_URL = process.env.REACT_APP_TIPO_MARCE_VEICOLO_PATH ?? '#'
export const TIPO_RELAZIONI_PERSONE_URL = process.env.REACT_APP_TIPO_RELAZIONI_PERSONE_PATH ?? '#'

// user service
export const USER_SERVICE_SERVER_URL = process.env.REACT_APP_USER_SERVICE_SERVER_URL ?? 'https://userservice.6sicuro.it/api/v1'
export const USER_LOGIN_URL = USER_SERVICE_SERVER_URL + '/users/login'
export const USER_REGISTER_URL = USER_SERVICE_SERVER_URL + '/users/register' 
export const FERTCH_USERE_DATA_URL = USER_SERVICE_SERVER_URL + '/users/my-data?with_qr_form_lists=1'
export const ADD_UPDATE_COMPANY_URL = USER_SERVICE_SERVER_URL + '/companies/upsert?get_back_companies=1'
export const ADD_UPDATE_PERSON_URL = USER_SERVICE_SERVER_URL + '/persons/upsert?get_back_people=1'

export const RECALL_URL = USER_SERVICE_SERVER_URL + '/quote-request/recall-me'

export const ZUKO_TRAK_CODE = process.env.REACT_APP_ZUKO_ID ?? ''